<template>
	<div id="card" style="max-width:400px;position:relative;height:100%;max-height:400px;">

		<div v-if="this.text && !this.cardtitle && !this.subtitle"
			style="display:flex;position:absolute;background:transparent;width:100%;height:100%;flex-direction: column;justify-content: center;">
			<div id="headline" style="padding:10px;text-align: center;color:white;font-weight:900;overflow:scroll;">
				<h3 id="headline">
					{{ this.text }}
				</h3>
			</div>
		</div>

		<div v-if="this.cardtitle || this.subtitle" id="footer"
			style="display:flex;flex-direction: column;justify-content: end;">
			<div style="flex-grow:1;overflow:hidden;margin-top:0px;">
				<div
					style="color:white;height:100%;display:flex;align-items: center;justify-content: center;text-align: center;">
					<div style="color:white;padding-top:20px;">
						<h3 id="headline">
							{{ this.text }}
						</h3>
					</div>


				</div>

			</div>

			<div v-if="this.tint" :id="this.isDark() ? 'tint-dark' : 'tint-light' ">&nbsp;</div>
			<div v-if="this" id="content" :class="this.mode" style=" justify-content: center;" :style=" this.background ? 'background:' + this.background : '' ">
				<h3 v-if="this.cardtitle" id="title">{{ this.cardtitle }}</h3>
				<b v-if="this.subtitle" id="subtitle">{{ this.subtitle }}</b>
			</div>


		</div>


	</div>
</template>
<script>

/* 
// bilderna ska ligga i card/
<Card filename="mc2.jpg" cardtitle="CYKEL" subtitle="www.boove.se/cykel" text="THIS IS THE NIGHT" tint="true" background="red"/>

*/


export default {
	name: "Card",
	components: {},
	props: {
		filename: {
			type: String,
			default: "kolfiber.jpg"
		},
		cardtitle: String,
		subtitle: String,
		text: String,
		mode:{
			type: String,
			default: "dark"
		},
		tint:{
			type: Boolean,
			default: false
		},
		background:{
			type:String,
			default: null
		},
		position:{
			type: String,
			default: "top left"
		},
		fontSizeTitleMax:{
			type: String,
			default: "180%"
		}
	},
	data() {
		return {
		};
	},

	computed:{
		imagepath(){

			if (this.filename){
				return require("@/assets/card/" + this.filename);
			}else{
				return require("@/assets/card/kolfiber.jpg");
			}

			
		},
		imagePathCSS(){
			return "url(" + this.imagepath + ")";
			//return "url('~@/assets/card/mc.jpg')";
		},


		fontColorCSS(){
			if (this.isDark()){
				return "white";
			}else{
				return "black"
			}
			
		},
		backgroundPositionCSS(){
			return this.position;
		},

		fontSizeTitleMaxCSS(){
			return this.fontSizeTitleMax
		}
	},
	methods:{
		isDark() {
			return this.mode == "dark" || this.mode == "dark-carbon"
		},
	}
	
};
</script>

<style scoped>

div#card {
	background-image: v-bind(imagePathCSS);
	/* */
	/*background-image: url('~@/assets/card/mc.jpg'); /* */
	height: 100%;
	width: 100%;
	object-fit: contain;
	background-size: cover;
	box-shadow: rgba(25, 25, 25, 0.2) 0px 4px 10px 0px;
	border-radius: 10px 10px 10px 10px;
	container: card / inline-size;
	background-position: v-bind(backgroundPositionCSS);
}

div#footer{
	/*background: red;*/
	/*background-image: linear-gradient(to top, red, yellow);*/
	height: 100%;
	width:100%;
	
}


div#footer div#tint-dark {
	background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
	height:15%;
}

div#footer div#tint-light {
	background-image: linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0));
	height: 15%;
}

div#footer div#content {
	display: flex;
	flex-direction: column;
	background: rgba(0, 0, 0, 0.8);
	height:20%;
	color:white;
	border-radius: 0px 0px 9px 9px;
	text-align:center;
	padding-bottom:10px;

}
div#footer div#content.dark {
	background: rgba(0, 0, 0, 0.8);
}

div#footer div#content.dark-carbon{
	background-image: url('~@/assets/card/kolfiber.jpg');
	object-fit: contain;
	background-size: cover;
}

div#footer div#content.light{
	background: rgba(255, 255, 255, 0.9);
}

div#footer div#content h3{
	color:white;
	margin:0px;
	padding:0px;
	margin-top:5px;
	font-weight: bolder;
	max-width:100%;
}

div#footer div#content.light h3{
color: black;

}

h3#headline, h3#title, b#subtitle{
	color:v-bind(fontColorCSS);
}

h3#headline{
	font-size: 350%;
	line-height: 100%;
}

h3#title {
	font-size: v-bind(fontSizeTitleMaxCSS);
}

b#subtitle {
	font-size: 100%;
}

@container card (width < 200px) {

	h3#headline {
		font-size: 25cqi;
	}

	h3#title {
		font-size: 11cqi;
		border:5px solid transparent;
	}

	b#subtitle {
		font-size: 80%;
	}
}


</style>